<!-- <mat-progress-bar mode="buffer" color="primary" *ngIf="loadingService.loading$ | async"></mat-progress-bar> -->
<mat-progress-bar mode="determinate" color="primary" [value]="loadingService.progress$ | async" *ngIf="loadingService.loading$ | async"></mat-progress-bar>
